// 디자인 토큰(globals.css) 기반 상태 톤. Badge / Banner 등에서 공통 사용.

export type Tone = "primary" | "ok" | "warn" | "danger" | "neutral";

export const TONE: Record<Tone, { soft: string; fg: string; dot: string }> = {
  primary: { soft: "var(--primary-soft)", fg: "var(--primary)", dot: "var(--primary)" },
  ok: { soft: "var(--ok-soft)", fg: "var(--ok)", dot: "var(--ok)" },
  warn: { soft: "var(--warn-soft)", fg: "var(--warn)", dot: "var(--warn)" },
  danger: { soft: "var(--danger-soft)", fg: "var(--danger)", dot: "var(--danger)" },
  neutral: { soft: "var(--surface-2)", fg: "var(--muted)", dot: "var(--faint)" },
};
